import { render, staticRenderFns } from "./CreditsPage.vue?vue&type=template&id=52356039&lang=pug&"
import script from "./CreditsPage.vue?vue&type=script&lang=ts&"
export * from "./CreditsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports